import AdvancedFiltersModal from "../../../../../../../../components/common/AdvanceFilterModal";
import { FilterContexType } from "../../../../../../../../components/layout/ViewHeader";
import { useFiltersRegistry } from "../../../../../../../../context/FiltersProvider";

type Props = {
	workspace: "baseline" | "comparison";
	filterContext: FilterContexType;
};

export const RootCauseAdvancedFilters = ({ workspace, filterContext }: Props) => {
	const { rootCauseState, dispatchRootCauseAdvancedForm } = useFiltersRegistry();

	const advancedForm = rootCauseState[workspace].advancedForm;

	return (
		<AdvancedFiltersModal
			filterContext={filterContext}
			items={advancedForm}
			dispatch={(action) => dispatchRootCauseAdvancedForm(workspace, action)}
		/>
	);
};
